import { ReactNode, useContext, useState } from "react";
import Auth, { AuthProps } from "../../api/auth";
import AuthCodeApi from "../../api/auth-code";
import AuthCode from "../../types/auth-code";
import AuthContext from "../auth-context";
import { ActiveTab } from "./active-tab";
import Login from "./login";

export interface LoginContainerProps {
  children: ReactNode;
}

const LoginContainer = ({ children }: LoginContainerProps) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [customerType, setCustomerType] = useState("Person");
  const [alert, setAlert] = useState(false);
  const [activeTab, setActiveTab] = useState<ActiveTab>("login");
  const context = useContext(AuthContext);

  const handleLogin = (data: AuthProps) => {
    setAlert(false);
    Auth.login(data).then((data) => {
      data.LoginId ? context.login(data.LoginId) : setAlert(true);
    });
  };

  const handleForgot = (data: AuthCode) => {
    setAlert(false);
    setUsername(data.username);
    const api = new AuthCodeApi();
    api.post(data).then((data) => {
      data.errorMessage ? setAlert(true) : setActiveTab("reset");
    });
  };

  const handleReset = (data: AuthCode) => {
    setAlert(false);
    const api = new AuthCodeApi();
    api.put(data).then((response) => {
      response.errorMessage
        ? setAlert(true)
        : handleLogin({
            username: data.username,
            password: data.code!,
            serviceType: data.serviceType,
          });
    });
  };

  const handleCustomerTypeToggle = () => {
    setCustomerType((c) => (c === "Person" ? "Company" : "Person"));
  };

  return context.authId ? (
    <>{children}</>
  ) : (
    <Login
      activeTab={activeTab}
      alert={alert}
      customerType={customerType}
      username={username}
      password={password}
      onActiveTabChange={setActiveTab}
      onCustomerTypeToggle={handleCustomerTypeToggle}
      onUsernameChange={setUsername}
      onPasswordChange={setPassword}
      onForgotPassword={handleForgot}
      onResetPassword={handleReset}
      onLogin={handleLogin}
    />
  );
};

export default LoginContainer;
